import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  rootInline: {
    padding: 0,
    boxShadow: theme.shadows[1],
    [theme.breakpoints.down('sm')]: {
      padding: '0 20px',
      paddingBottom: 20,
    },
  },
  rootInlineContent: {
    padding: '0 !important',
  },
  tooltipRadioBtn: {
    alignSelf: 'center',
  },
  radio: {
    display: 'flex',
    flexDirection: 'column',
  },
  inline: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  head: {
    padding: '14px 0',
    background: '#f9f9f9',
    textAlign: 'center',

    [theme.breakpoints.down('sm')]: {
      background: 'none',
      textAlign: 'left',
      padding: '5px 0',
    },
  },
  title: {
    fontWeight: 700,
  },
  defaultText: {
    fontSize: 14,
    marginLeft: 4,
  },
  tailText: {
    fontSize: 13,
  },
  tail: {
    marginLeft: 60,
    marginRight: 20,

    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  commonFee: {
    fontStyle: 'normal',
    display: 'inline-flex',
    alignItems: 'center',
  },
}));
